import { typeObligations } from "./obligation"
import { queryCustomerObligation } from "./queries/queryCustomerObligation"

const obligationSchema = {
  types: [typeObligations],
  resolvers: {
    Query: {
      ...queryCustomerObligation,
    },
    Mutation: {},
  },
}

export default obligationSchema
